import http from './http';

export type FlagIssueType =
  | 'school_data_wrong'
  | 'essay_wrong'
  | 'bug_ui'
  | 'task_req_wrong'
  | 'other';

export const FLAG_ISSUE_TYPE_OPTIONS: { value: FlagIssueType; label: string }[] = [
  { value: 'school_data_wrong', label: 'School data is wrong' },
  { value: 'essay_wrong', label: 'Essay prompt is wrong' },
  { value: 'bug_ui', label: 'Bug / UI issue' },
  { value: 'task_req_wrong', label: 'Task or requirement is wrong' },
  { value: 'other', label: 'Other' },
];

export interface FlagIssuePayload {
  issue_type?: FlagIssueType;
  message: string;
  surface?: string;
  page_url?: string;
  school_name?: string;
  user_name?: string;
}

const flagIssueService = {
  async submitFlag(payload: FlagIssuePayload) {
    const res = await http.post('api/flag-issue', payload);
    return res;
  },
};

export default flagIssueService;
